<template>
    <div class="login">
        <div class="row row--fullwidth">
            <div class="col lg-6 sm-12">
                <div class="login-form" v-if="!error" key="forms">
                    <transition name="fade" mode="out-in">
                        <form v-if="!changeSuccess" key="form">
                            <div class="login-form__title text_15 text_bold">{{ $t("change_password_title") }}</div>
                            <div class="text_11">
                                {{ $t("enter_new_password") }}
                            </div>
                            <div class="form-group" v-for="(input, name, inputIndex) in formConfirm" :key="inputIndex">
                                <Input
                                    :inputClass="input.inputClass"
                                    :isValid="input.required ? input.isValid : true"
                                    :validationMessage="input.required ? input.validationMessage : ''"
                                    :type="input.type"
                                    :name="name"
                                    :label="input.label"
                                    :labelDescription="input.labelDescription"
                                    :required="input.required"
                                    :cleaveOptions="input.cleaveOptions"
                                    v-model="input.value"
                                    :suggestion="input.suggestion" />
                            </div>
                            <div class="form-group login-submit">
                                <div
                                    class="button button--dark button--wide"
                                    :class="{ 'button--loading button--disabled': loading }"
                                    @click="changePassword">
                                    {{ $t("send") }}
                                </div>
                            </div>
                        </form>
                        <div v-else key="success">
                            <div class="login-form__title text_15 text_bold">{{ $t("password_changed") }}</div>
                            <div class="text_11">
                                {{ $t("password_changed_text") }}
                            </div>
                            <div class="form-group login-submit">
                                <nuxt-link
                                    :to="{ name: 'lk-login', query: $route.query }"
                                    class="button button--dark button--wide"
                                    >{{ $t("lk_log_in") }}</nuxt-link
                                >
                            </div>
                        </div>
                    </transition>
                    <transition name="fade">
                        <div class="error text_11" v-if="errorMessage">{{ errorMessage }}</div>
                    </transition>
                </div>
                <div class="login-form" v-else>
                    <div class="login-form__title text_15 text_bold">{{ $t("error") }}</div>
                    <div class="text_11">
                        {{ $t("wrong_link") }}
                    </div>
                </div>
            </div>
            <div class="col lg-6 sm-12 col--no-padding login-img">
                <img v-lazy-load data-src="/img/forget-pass.jpg" v-lazy-load data-srcset="/img/forget-pass@2x.jpg 2x" alt="" />
            </div>
        </div>
    </div>
</template>
<script>
import Input from "~/components/form/Input";
import { mapGetters } from "vuex";
export default {
    name: "Reset",
    components: {
        Input,
    },
    data() {
        return {
            errorMessage: "",
            error: false,
            submitSuccess: false,
            changeSuccess: false,
            loading: false,
            formConfirm: {
                code: {
                    type: "hidden",
                    value: this.$route.query.code,
                },
                password: {
                    label: this.$i18n.t("new_password"),
                    type: "password",
                    required: true,
                    isValid: true,
                    validationMessage: "",
                    value: "",
                    inputClass: "black-border",
                },
            },
        };
    },
    watch: {
        async langust() {
            this.$store.commit("crumbs/change", this.crumbs);
        },
    },
    computed: {
        ...mapGetters({
            langust: "globalvars/getLang",
        }),
        crumbs() {
            return [
                {
                    name: this.$i18n.t("change_password_title"),
                },
            ];
        },
    },
    methods: {
        async changePassword() {
            this.loading = true;
            this.errorMessage = "";
            await this.$axios.get("/api/auth/xsrf_token");

            try {
                let res = await this.$axios.post("/api/reset_password/reset", {
                    code: this.formConfirm.code.value,
                    password: this.formConfirm.password.value,
                });
                if (res.data.success == 1) {
                    this.changeSuccess = true;
                } else {
                    this.submitSuccess = false;
                    this.processError(res, this.formConfirm);
                }
            } catch (error) {
                this.processError(error, this.formConfirm);
            }
            this.loading = false;
        },
        processError(error, form) {
            this.isLoading = false;
            if (error.response) {
                if (error.response.status == 406) {
                    let notValidFields = error.response.data.data;
                    for (const key in notValidFields) {
                        if (notValidFields.hasOwnProperty(key)) {
                            const element = notValidFields[key];
                            let name = key.split(".").length > 1 ? key.split(".")[1] : key;
                            if (form[name]) {
                                form[name].isValid = false;
                                form[name].validationMessage = element[0];
                            }
                        }
                    }
                    let first_key = Object.keys(notValidFields)[0];
                    let first_name = first_key.split(".").length > 1 ? first_key.split(".")[1] : first_key;
                    let elem = document.querySelector(`[name="${first_name}"]`);
                    if (elem) {
                        elem.scrollIntoView({ block: "center", behavior: "smooth" });
                        elem.focus();
                    }
                } else {
                    this.errorMessage = error.response.data.error;
                }
            } else {
                console.log(`error =>`, error);
            }
        },
    },
    async mounted() {
        this.$store.commit("crumbs/change", this.crumbs);
        try {
            await this.$axios.get("/api/reset_password/get_email/" + this.$route.query.code);
        } catch (error) {
            this.error = true;
        }
    },
};
</script>
<style lang="less" scoped>
.button--wide {
    width: 66%;
}
.login {
    z-index: 1;
    background: #fff;
    &-img {
        img {
            width: 100%;
        }
    }
}
.login-form {
    padding-top: 40px;
    &__title {
        margin-bottom: 24px;
    }
    @media @sm {
        padding-top: 24px;
        padding-bottom: 24px;
    }
}
.login-submit {
    margin-top: 24px;
    margin-bottom: 16px;
    height: 48px;
    .button {
        height: 48px;
    }
    .button--text {
        text-decoration: underline;
        padding: 0 60px;
        margin-left: 16px;
        text-underline-offset: 3px;
        text-decoration-skip: none;
        text-decoration-skip-ink: none;
        @media @sm {
            margin-left: 0;
            margin-top: 8px;
            width: 100%;
        }
    }
    @media @sm {
        height: auto;
        flex-direction: column;
    }
}
</style>
